import { Directive } from '@angular/core';
import { NotificationCenterWindow } from '../notification-center/notification-center-modal.component';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';

@Directive({
    selector: '[notification-icon]',
    host: {
        '(click)': 'onClick()'
    }
})
export class NotificationIconDirective {
    constructor(
        private modalService: MvdModalService
    ) {}

    onClick() {
        this.modalService.open(NotificationCenterWindow);
    }
}
